<div class="container migrations-container">
  <ziro-breadcrumbs></ziro-breadcrumbs>

  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  }

  @if (!isLoading) {
    <ziro-migrations-create-form [allAssessments]="allAssessments"></ziro-migrations-create-form>
  }
</div>
